module.exports = __webpack_public_path__ + "img/microneedling-treatment-mobile-en.db06e012.jpg";